import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PasswordResetStoreEffects } from './effects';
import { passwordResetReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('passwordReset', passwordResetReducer),
    EffectsModule.forFeature([PasswordResetStoreEffects]),
  ],
})
export class PasswordResetStoreModule {}
